import { render } from "./SignoffTask.vue?vue&type=template&id=77878ed4"
import script from "./SignoffTask.vue?vue&type=script&lang=js"
export * from "./SignoffTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__